import { gql } from "apollo-boost";
import React from "react";
import Box from "../../components/Box";
import Card from "../../components/Card";
import Link from "../../components/Link";
import Text from "../../components/Text";
import Product, { fragments as ProductFragments } from "./Product";

function ProductCard(props) {
  const {
    to,
    bottleImage,
    producer,
    stand,
    varietiesText,
    wineType,
    wineColor,
    bg,
    variant,
    mb = 3,
    withBorder
  } = props;
  const { producerName } = producer || {};
  if (variant === "mini") {
    return (
      <Text as="div" variant="xs" mb={mb} minWidth={80}>
        <Link display="block" variant="hover" to={to}>
          <Box bg={bg} border="soft" p={3} mb={2}>
            <Product.Image
              image={bottleImage}
              maxWidth={128}
              mx="auto"
              wineType={wineType}
              wineColor={wineColor}
            />
          </Box>
          {producerName && <Product.Producer producerName={producerName} />}
          <Product.Name
            product={props}
            component={Text}
            as="div"
            css={{ textOverflow: "ellipsis", overflow: "hidden" }}
          />
        </Link>
      </Text>
    );
  }

  return (
    <Product as={Card} withBorder={withBorder} bg={bg} to={to} mb={mb}>
      <Product.Visual width={[1 / 6, 1 / 8]} minWidth={64} pl={0}>
        <Product.Image
          image={bottleImage}
          wineColor={wineColor}
          wineType={wineType}
        />
      </Product.Visual>

      <Product.Main flex="1" pr={0}>
        {stand && <Product.Stand stand={stand} />}
        {producerName && <Product.Producer producerName={producerName} />}
        <Product.Name product={props} />
        <Product.Varieties text={varietiesText} />
      </Product.Main>
    </Product>
  );
}

export default React.memo(ProductCard);

export const fragment = gql`
  fragment ProductCard on Product {
    id
    ...ProductImage
    ...ProductStand
    ...ProductProducerName
    ...ProductName
    ...ProductVarieties
  }
  ${ProductFragments.image}
  ${ProductFragments.stand}
  ${ProductFragments.producerName}
  ${ProductFragments.name}
  ${ProductFragments.varieties}
`;
